import React from "react";
import { useLocation } from "react-router-dom";
import { Box, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";

const DesktopMenu = ({ menuItems = [], themeMode, toggleTheme }) => {
  const location = useLocation();
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: { xs: "none", sm: "flex" },
        gap: 2,
        alignItems: "center",
        marginLeft: "auto",
        maxWidth: "100%",
        overflowX: "hidden",
      }}
    >
      {menuItems.map((item, index) => (
        <Typography
          key={index}
          component={Link}
          to={item.path}
          sx={{
            textDecoration: "none",
            fontWeight: location.pathname === item.path ? "bold" : "normal",
            color: theme.palette.mode === "dark" ? "white" : "black",
            "&:hover": {
              color: theme.palette.primary.main,
            },
          }}
        >
          {item.text}
        </Typography>
      ))}
    </Box>
  );
};

export default DesktopMenu;